import { useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import {
  LINKS,
  detectMobilePlatform,
  storeUrlForPlatform,
} from '../config/links'
import { Seo } from '../seo/Seo'
import './DownloadApp.css'

export function DownloadApp() {
  const platform = useMemo(() => detectMobilePlatform(), [])
  const target = storeUrlForPlatform(platform)
  const redirecting = platform !== 'other'

  useEffect(() => {
    if (!redirecting) return
    const timer = window.setTimeout(() => {
      window.location.replace(target)
    }, 400)
    return () => window.clearTimeout(timer)
  }, [redirecting, target])

  return (
    <main className="get-app">
      <Seo
        title="Get the App"
        description={
          redirecting
            ? 'Redirecting to the Music24 app store listing for your device.'
            : 'Download Music24 for iOS, Android, or launch the web app.'
        }
        path="/download-app"
        noindex
      />

      <div className="get-app__glow" aria-hidden />

      <div className="get-app__content">
        <img
          className="get-app__logo"
          src="/web-app-manifest-192x192.png"
          alt=""
          width={72}
          height={72}
        />

        {redirecting ? (
          <>
            <h1>Opening the store…</h1>
            <p>Taking you to Music24 for your device.</p>
            <a className="get-app__continue" href={target}>
              Tap here if nothing happens
            </a>
          </>
        ) : (
          <>
            <h1>Get Music24</h1>
            <p>Jewish music radio — free, live, 24/6.</p>

            <div className="get-app__actions">
              <a className="get-app__btn get-app__btn--primary" href={LINKS.iosAppStore}>
                App Store — iPhone, iPad & Mac
              </a>
              <a
                className="get-app__btn get-app__btn--primary"
                href={LINKS.androidPlayStore}
              >
                Google Play
              </a>
              <a
                className="get-app__btn get-app__btn--ghost"
                href={LINKS.webApp}
                target="_blank"
                rel="noopener noreferrer"
              >
                Launch web app
              </a>
            </div>

            <Link className="get-app__more" to="/download">
              More download options
            </Link>
          </>
        )}
      </div>
    </main>
  )
}
